import fetch from 'utils/fetch';

export function fastQuery(keyword) {
    return fetch({
        url: '/fastQuery',
        method: 'get',
        params: {keyword}
    });
}
export function cdrQuery(time, pageSize,page,imsi) {
    const data = {
        time,
        pageSize,
        page,
        imsi
    };
    return fetch({
        url: '/cdrQuery',
        method: 'get',
        params : data
    });
}
export function checkNotify() {
    return fetch({
        url: '/checkNotify',
        method: 'get'
    });
}




// WEBPACK FOOTER //
// ./src/api/fastQuery.js